/*const isProd = process.env.NODE_ENV === 'production';

const config = {
  API_URL: isProd
    ? ('https://' + window.location.host + '/api')
    : 'https://localhost:44355',

  DEPLOY_URL: isProd
    ? 'https://ozgnqs01.itom.report/api'
    : 'https://localhost:44355',

  ICON_PANEL_API_URL: 'https://iconpanel.ozg-manager.site/api',
  ICON_PANEL_APP_URL: 'https://iconpanel.ozg-manager.site/',
  VERSION: '2.0.1',
  APP_KEY: 'c2790ece23bcb7656ffef842d9f51054',
};

console.log('[ozg-system config]', config);
export default config;
*/


import { resolveApplicationBase } from './api-url';

const host = window.location.hostname;
const origin = window.location.origin;

const isLocalhost =
  host === 'localhost' ||
  host === '127.0.0.1' ||
  host === '::1';

const config = {
  API_URL: resolveApplicationBase(window.location),

  DEPLOY_URL: resolveApplicationBase(window.location),

  ICON_PANEL_API_URL: 'https://iconpanel.ozg-manager.site/api',
  ICON_PANEL_APP_URL: 'https://iconpanel.ozg-manager.site/',
  VERSION: '2.0.1',
  APP_KEY: 'c2790ece23bcb7656ffef842d9f51054',
};

console.log('[ozg-system config]', {
  host,
  origin,
  isLocalhost,
  API_URL: config.API_URL,
  DEPLOY_URL: config.DEPLOY_URL
});

export default config;
